export const LOADING = 'eateryLanding.LOADING';
export const LOADED = 'eateryLanding.LOADED';
